var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":_vm.isLoading,"height":100,"is-full-page":_vm.fullPage,"width":100,"background-color":"#160200","color":"#fe7031","loader":"bars"},on:{"update:active":function($event){_vm.isLoading=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }